<template>
  <div class="pageloader is-active">
    <span class="title has-text-white">
      Verificando cuenta...
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'VerifyEmail',
  beforeRouteEnter(to, from, next) {
    if (!to.query.token) next({ name: 'Home' });
    else next();
  },
  async mounted() {
    try {
      await this.verifyEmail(this.$route.query.token);

      this.$success({ message: 'Correo verificado exitosamente.' });

      this.$router.replace({ name: 'Home' });
    } catch (error) {
      this.$danger({ message: 'Token invalido.' });

      this.$router.replace({ name: 'VerificationPending' });
    }
  },
  methods: mapActions({ verifyEmail: 'auth/verifyEmail' }),
};
</script>

<style scoped>
.pageloader {
  background: none;
  z-index: 2;
}
</style>
